/**
 * searchOpen.js
 * Handles toggling off-screen navigation
 */
export default class Search {
    constructor() {
        this.settings = {
            searchOpen: document.querySelector('[data-search-toggle]'),
            searchOverlay: document.getElementById('site-search'),
            searchField: document.querySelector('.search-field'),
            searchClose: document.getElementById('search-close'),
            body: document.body,
            activeClass: 'js-search-open',
            overlayClass: 'js-overlay-active'
        };
    }

    init() {
        if (this.settings.searchOpen && this.settings.searchOverlay) {
            this.bindUIActions();
        } else {
            console.warn('Search elements not found:', {
                searchOpen: !!this.settings.searchOpen,
                searchOverlay: !!this.settings.searchOverlay
            });
        }
    }

    bindUIActions() {
        const { searchOpen, searchClose } = this.settings;

        window.addEventListener('resize', () => {
            if (window.innerWidth < 899) this.activeClass('remove');
        });

        searchOpen.addEventListener('click', () => {
            this.activeClass();
        });

        searchClose.addEventListener('click', () => {
            this.activeClass('remove');
        });
    }

    activeClass(status) {
        const { body, searchOverlay, searchField, searchOpen, activeClass, overlayClass } = this.settings;
        const isActive = body.classList.contains(activeClass);

        if (isActive || status === 'remove') {
            body.classList.remove(activeClass);
            searchOverlay.classList.remove(overlayClass);
            searchOpen.setAttribute('aria-expanded', 'false');
            searchOpen.setAttribute('aria-label', 'Open Search Menu');
        } else {
            body.classList.add(activeClass);
            searchOverlay.classList.add(overlayClass);
            searchOpen.setAttribute('aria-expanded', 'true');
            searchOpen.setAttribute('aria-label', 'Close Search Menu');

            // Focus the search field when opening - use setTimeout to ensure DOM is updated
            if (searchField) {
                setTimeout(() => {
                    searchField.focus();
                }, 10);
            }
        }
    }
}
